/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Description_SelectedInputs */

const en_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

const fr_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selectionnes`)
};

const de_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ausgewählt`)
};

const it_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selezionato`)
};

const ru_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`выбранный`)
};

const es_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seleccionado`)
};

const zh_cn2_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选定`)
};

const ja_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択された`)
};

const hi_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित`)
};

const pt_pt2_position_modal_description_selected = /** @type {(inputs: Position_Modal_Description_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selecionado`)
};

/**
* | output |
* | --- |
* | "selected" |
*
* @param {Position_Modal_Description_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_description_selected = /** @type {((inputs?: Position_Modal_Description_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Description_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_description_selected(inputs)
	if (locale === "de") return de_position_modal_description_selected(inputs)
	if (locale === "it") return it_position_modal_description_selected(inputs)
	if (locale === "ru") return ru_position_modal_description_selected(inputs)
	if (locale === "es") return es_position_modal_description_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_description_selected(inputs)
	if (locale === "ja") return ja_position_modal_description_selected(inputs)
	if (locale === "hi") return hi_position_modal_description_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_description_selected(inputs)
	return en_position_modal_description_selected(inputs)
});